import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import SickIcon from '@mui/icons-material/Sick';
import { UserMinus, ChartBar, Plus, Calendar, BellMinus, Pill, ChartPie, ClockAlert, ShieldUser } from 'lucide-react';
import { CircularProgress, Snackbar, Alert } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'; 
import { IconUserCode } from '@tabler/icons-react';
import Absence from '../../components/tables/Absence.jsx';
import { useRef } from 'react';
import {getAllEmployees} from '../../services/EmployeeService';
import AbsenceForm from '../../components/Forms/AbsenceForm';
import Employee from '../../assets/employee.gif';
import EmployeeCard from '../../components/lists/EmplyeeList.jsx'; 
import PageHeader from '../../components/headers/Header'
import AbsenceDetailsModal from '../../components/DViews/AbsenceDetailsModal';
import AbsenceCalendar from '../../components/calendars/AbsenceCalendar';
import DayDetailsModal from '../../components/DViews/CDayDetails.jsx';
import AbsenceDashboard from '../../components/dash/AbsenceDash';
import JustificationUploadModal from '../../components/DViews/JUModal.jsx';
import AbsenceKPIDashboard from '../../components/KPIDashs/AbsenceKPI.jsx';
import LeaveRequestPage from './leaveRequestPage';
import LeaveRequestForm from '../../components/Forms/LeaveRequestForm';
import FormHeader from '../../components/headers/FormHeader.jsx';
import { getPendingRequestsOlderThan15Days, getApprovedLeaves, getAllLeaves, getSickLeaves, approveLeave, rejectLeave, getLeavesPerDepartment, getMyLeaves } from '../../services/leavesAPIs';

import {getAllAbsences, getMyAbsences, getAllStagedAbsences, deleteAbsence} from '../../services/absenceAPIs';
import { exportToPdf } from '../../utils/exportToPdf'; 
import { useMediaQuery, Fab, Typography, Box } from '@mui/material';

import '../../components/leaves/Leaves.css';

const NotEmployee = localStorage.getItem('userRole')!=='EMPLOYEE';

const FillSickness = () => {
  const [IsEmployee, setIsEmployee]=useState(localStorage.getItem('userRole')==='EMPLOYEE');
  const navigate = useNavigate();
  const [stagedAbsences, setStagedAbsences]= useState([]);

  const dashboardRef = useRef(null);
  const absencesRef = useRef(null);
  const calendarRef = useRef(null);
  const unconfirmedAbsencesRef= useRef(null);
  const addRef = useRef(null);

  console.log(localStorage.getItem('token'));
  const isLargeScreen = useMediaQuery('(min-width: 1600px)');
  
  const location = useLocation(); // Get location

  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [selectedAbsence, setSelectedAbsence]= useState(null);
  const [employees, setEmployees] = useState([]);
  const [sickAbsences, setSickAbsences] = useState([]);
  const [lateAbsences, setLateAbsences] = useState([]);
  const [personalAbsences, setPersonalAbsences] = useState([]);

  const [currentDate] = useState(new Date('2025-06-19T10:26:00+01:00'));
  // const [activeTab, setActiveTab] = useState('overview');
  const [activeTab, setActiveTab] = useState(IsEmployee ? 'add' : 'add');
  const [showEmployeeCard, setShowEmployeeCard] = useState(false);

  // Calendar specific states
  const [selectedCalendarDate, setSelectedCalendarDate] = useState(null);
  const [dayAbsences, setDayAbsences] = useState([]);
  const [showDayDetailsModal, setShowDayDetailsModal] = useState(false);
  
  const [selectedUpload, setSelectedUpload] = useState(null);

  // Leaves
  const [leavesData, setLeavesData] = useState([]);
  const lb='handleWithEmployeeId';
   const [urgentRequests, setUrgentRequests] = useState([]);
   const [hasUrgentRequests, setHasUrgentRequests] = useState(false);
   const [loading, setLoading] = useState(true);

  // Initialize filters with potential state from navigation
  const initialFilters = {
    type: '',
    status: '',
    department: '',
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    search: '',
    includeLateness: true
  };

  const [filters, setFilters] = useState(initialFilters);
   
  
  // PDF states
  const [isExporting, setIsExporting] = useState(false);
  const [exportError, setExportError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    const state = location.state || {};
    setActiveTab(state.targetTab || (IsEmployee ? 'add' : 'add'));

    if (state.filters) {
      setFilters(prevFilters => ({
        ...prevFilters,
        year: state.filters.year || prevFilters.year,
        month: state.filters.month || prevFilters.month,
        office:
          state.filters.office === 'all'
            ? ''
            : state.filters.office || prevFilters.office,
      }));
    }

    if (state.targetTab) delete state.targetTab;
  }, [location.state, IsEmployee]);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  
  const handleEmployeeSelect = (id) => {
    setSelectedEmployeeId(id);
    setShowEmployeeCard(false);
    console.log('Selected employee ID:', id);
  };

  // Handle calendar date click
  const handleCalendarDateClick = (date, absencesForDay) => {
    setSelectedCalendarDate(date);
    setDayAbsences(absencesForDay);
    setShowDayDetailsModal(true);
  };
  
  // Data fetching
  useEffect(() => {
    const fetchData = async () => {
      try {
        const allEmployees = await getAllEmployees();
        setEmployees(allEmployees);
        console.log("All Employees:", allEmployees);
        console.log("All Employees:", employees);
  
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      };
    fetchData();
  }, []);


  const [absences, setAbsences] = useState([]);

  const fetchAbsences = async () => {
    try {
      let data=[];
      const stagedAbsencesData=await getAllStagedAbsences();
      if (IsEmployee) {
        data = await getMyAbsences();
      } else {
        data = await getAllAbsences();
      }
      setAbsences(data);
      setStagedAbsences(stagedAbsencesData);
      setSickAbsences(data.filter(abs => abs.ty_pe === 'SICKNESS'));
      setLateAbsences(data.filter(abs => abs.ty_pe === 'LATENESS'));
      setPersonalAbsences(data.filter(abs => abs.ty_pe === 'PERSONAL'));
      console.log('Absence management absences:', data);
    } catch (error) {
      console.error('Error fetching absences:', error);
    }
  };
  // Data fetching - update the useEffect
    const fetchData = async () => {
      setLoading(true);
      let allLeavesData = [];
      try {
        if (IsEmployee) {
          allLeavesData = await getMyLeaves();
        } else {
          allLeavesData = await getAllLeaves();
        }
        const urgentRequestsData = await getPendingRequestsOlderThan15Days();
          
        setLeavesData(allLeavesData);
        setUrgentRequests(urgentRequestsData);
        setHasUrgentRequests(urgentRequestsData.length > 0);
  
        const allEmployees = await getAllEmployees();
        setEmployees(allEmployees);
          
        console.log("Urgent Requests:", urgentRequestsData);
        console.log("All Leaves:", allLeavesData);
        console.log("All Employees:", allEmployees);
  
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Set loading to false
      }
    };

  // Initial fetch
  useEffect(() => {
    fetchAbsences();
    fetchData();
  }, [IsEmployee]);
  

  return (
    <div className="Leaves-main-container">

      <FormHeader
        title={'Add new sickness record'}
        icon={SickIcon}
        onBack={() => {navigate(-1)}}
      />
        {/* {activeTab === 'analytics' && <Analytics />} */}
        {activeTab === 'add' && !IsEmployee &&
         <Typography variant="h4" gutterBottom sx={{ mb: 1, ml:2.5 , fontWeight: 'bold', color: '#c01557' }}>
          👤 Don't forget to choose the employee
         </Typography>
        }
        {isLargeScreen ? (
        <div style={{display: 'flex', gap: '16px'}}>
          {activeTab === 'add' && employees.length>0 && !IsEmployee && <EmployeeCard employees={employees}  onSelectEmployee={handleEmployeeSelect} itemsPerPage={5}/>}
          {activeTab === 'add' && <AbsenceForm ty_pe={'SICKNESS'} IsEmployee={IsEmployee} fetchAbsences={fetchAbsences} employeeId={selectedEmployeeId} employees={employees} />}
        </div>
        ) : (
          <div style={{display: 'flex', gap: '16px'}}>
          {activeTab === 'add' && !IsEmployee &&
            <Fab
                onClick={() => setShowEmployeeCard(!showEmployeeCard)}
                sx={{
                  position: 'fixed',
                  bottom: 20,
                  right: 20,
                  zIndex: 1000,
                  backgroundColor: 'var(--card-bg, white)',
                  boxShadow: 3,
                }}
                  >
                  <img
                    src={Employee}
                    alt="Employee"
                    style={{ width: '40px', height: '35px', borderRadius:'5px' }} // Adjust size as needed
                    />   
                </Fab>
                } 
                {showEmployeeCard && (
                  <Box
                    sx={{
                    position: 'fixed',
                    bottom: 15,
                    right: 100,
                    width: '90%',
                    maxWidth: 500,
                    zIndex: 1000,
                    boxShadow: 3,
                    borderRadius: 2,
                    backgroundColor: 'var(--card-bg, white)',
                    p: 2,
                  }}
                  >
                    {activeTab === 'add' && employees.length>0 && <EmployeeCard employees={employees}  onSelectEmployee={handleEmployeeSelect} itemsPerPage={2}/>}
                  </Box>
                      )}

                {activeTab === 'add' && <AbsenceForm ty_pe={'SICKNESS'} IsEmployee={IsEmployee} fetchAbsences={fetchAbsences} employeeId={selectedEmployeeId} employees={employees} />}
            </div>

        )}       
    </div>
  );
};

export default FillSickness;